import React from 'react';
import {withLoader} from "../../hocs/withLoader";
import {AccountCardListCardListItem} from "./AccountCardListItem";
import {AdminAccountReportVO} from "../../../types/admin/AdminAccountReportVO";
import { DialogType } from './actions/data';
import InfoCardLoadingSkeleton from "../../skeleton/InfoCardLoadingSkeleton";

interface AccountCardListProps {
  accounts?: AdminAccountReportVO[];
  collapseByIndex: boolean[];
  onToggleCollapse: (index: number) => void;
  setOpenModal: (modal: DialogType) => void;
  isSuperAdmin: boolean;
  setAccountBeingActioned: (account: AdminAccountReportVO) => void;
}

/**
 * Component that takes a list of accounts and conditionally renders them
 * @param accounts list of accounts to display
 * @param collapseByIndex array of booleans describing whether items should be collapsed or not
 * @param onToggleCollapse function callback when an item is clicked to determine whether to expand/collapse
 * @param setOpenModal function to control opening/closing a modal and specify the modal type
 * @param isSuperAdmin boolean flag indicating whether the current user has super admin privileges
 * @param setAccountBeingActioned function to set the account currently being targeted for an admin action
 * @constructor
 */
const AccountCardList = ({accounts = [], collapseByIndex, onToggleCollapse, setOpenModal, isSuperAdmin, setAccountBeingActioned}: AccountCardListProps) => {
  return accounts.map((account, index) => (
      <AccountCardListCardListItem key={account.id}
                                   account={account}
                                   collapse={collapseByIndex[index]}
                                   onToggleCollapse={() => onToggleCollapse(index)}setOpenModal={setOpenModal}
                                        isSuperAdmin={isSuperAdmin}
                                        setAccountBeingActioned={setAccountBeingActioned}
      />
    )
  )
}

/**
 * Component that conditionally renders the base component or the loader depending upon its isLoading prop
 */
const AccountCardListWithLoader = withLoader(AccountCardList, InfoCardLoadingSkeleton);

export {AccountCardListWithLoader};
